import React, { useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import TimeAgo from "handy-timeago";
import { Tooltip } from "react-tooltip";

import NotificationType from "./NotificationType";
import NotificationActionType from "./NotificationActionType";

import avatarSrc from "../../../assets/icons/default-avatar.svg";

import {
  changeNotificationStatusAction,
  getNotificationsAction,
} from "../actions/notification-actions";

const NotificationList = (props) => {
  const navigate = useNavigate();

  const {
    notifyByName,
    type,
    user_username,
    featureSubType,
    notifyTime,
    status,
    notifyId,
    updateNotificationStatus,
    getNotificationList,
    setNotifications,
    slideData,
    userImageSrc,
    groupName,
  } = props;

  const [clicked, setClicked] = useState(false);

  const handleNotificationClick = (id) => {
    setClicked(true);

    updateNotificationStatus(id);
    getNotificationList();
  };

  const convertUTCDateToLocalDate = (date) => {
    return date - 60 * 1000;
  };

  const loadInViewer = (slideData) => {
    const { dzi_key_folder, dzi_thumbnail } = slideData || {};

    if (dzi_key_folder && dzi_thumbnail) {
      navigate({
        pathname: "/viewer",
        search: `?image=${dzi_key_folder}&thumb=${dzi_thumbnail}&isAnalysis=true`,
      });
    }
  };

  return (
    <div
      className={`noti follow_noti ${
        status === "read" || clicked === true
          ? "read"
          : status === "unread" || clicked === false
          ? "unread"
          : "read"
      }`}
      onClick={() => handleNotificationClick(notifyId)}
    >
      <div className="noti_left">
        <img
          src={userImageSrc || avatarSrc}
          className="noti_avatar"
          alt="avatar"
        />

        {type === "slidebox" && slideData && (
          <a
            className="noti_bold"
            data-tooltip-id="notification-tooltip"
            data-tooltip-content={
              slideData?.slide_original_name
            }
            onClick={() => loadInViewer(slideData)}
          >
            {slideData?.slide_original_name?.length > 12
              ? `${slideData.slide_original_name.substring(0, 12)}...`
              : slideData?.slide_original_name}{" "}
          </a>
        )}

        {type === "case" && (
          <a
            className="noti_bold"
            label={slideData?.slide_original_name}
            onClick={() => loadInViewer(slideData)}
          />
        )}

        <NotificationType
          featureSubType={featureSubType}
          user_username={user_username}
          file_name={featureSubType}
          notifyByName={notifyByName}
          notificationType={type}
          groupName={groupName}
        />

        <span className="noti_time">
          {TimeAgo(
            convertUTCDateToLocalDate(new Date(notifyTime))
          )}
        </span>
      </div>

      <NotificationActionType
        details={{ ...props }}
        setNotifications={setNotifications}
      />

      <Tooltip
        id="notification-tooltip"
        place="bottom"
        variant="dark"
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  notificationList: state.Notifications.notificationList,
  showLoader: state.Notifications.showLoader,
});

const mapDispatchToProps = (dispatch) => ({
  updateNotificationStatus: (id) =>
    dispatch(changeNotificationStatusAction(id)),

  getNotificationList: () =>
    dispatch(getNotificationsAction()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NotificationList);